<template>
    <div class="geoFencingPage public_box">
        <div class="content_box tableParent">
            <div class="search_box flex">
                <!--检索部分-->
                <el-form :inline="true" :model="geoFenceListForm" class="demo-form-inline">
                    <el-form-item label="围栏名称：">
                        <el-input class="width_150" v-model="geoFenceListForm.condition.keyword" size="small" placeholder="请输入围栏名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="onQueryGeoFenceListClicked" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-button type="primary" size="small" @click="onGeoFenceAddClicked('add')">添加新围栏</el-button>
            </div>
            <!--table表格部分-->
            <el-table ref="multipleTable" class="tableHeightAdaptive" :data="geoFenceList" v-loading="geoFenceListLoading" :height="tableHeight" style="width: 100%">
                <!-- <el-table-column type="index" label="序号" width="50"></el-table-column> -->
                <el-table-column prop="remindName" label="围栏名称"></el-table-column>
                <el-table-column label="围栏区域">
                    <template slot-scope="scope">
                        {{ getRegionNameByRegionId(scope.row.regionId) || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="remindSettingTypeName" label="事件类型"></el-table-column>
                <el-table-column label="触发条件">
                    <template slot-scope="scope">
                        {{ scope.row.triggerValue + scope.row.triggerUnit }}
                    </template>
                </el-table-column>
                <el-table-column label="报警类型">
                    <template slot-scope="scope">
                        {{ scope.row.remindModeName && scope.row.remindModeName.length ? scope.row.remindModeName.join(' + ') : '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="报警状态" width="130">
                    <template slot-scope="scope">
                        <div>
                            <el-switch :value="scope.row.enableFlag" @change="toggleGeoFence(scope.row, scope.$index)" active-color="#409EFF" inactive-color="#C0C0C0"> </el-switch>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editGeoFenceInfo(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="delGeoFence(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页部分-->
            <el-pagination style="margin-top: 0.2rem" @current-change="onGeoFencePageNoChanged" :current-page="geoFenceListForm.pageNo" layout="total, prev, pager, next, jumper" :page-size="geoFenceListForm.pageSize" :total="geoFenceListTotalPage"> </el-pagination>
        </div>
        <el-dialog :title="geoFenceFormTitle" center :visible.sync="geoFenceFormVisible" destroy-on-close append-to-body :modal-append-to-body="false" width="1200px">
            <div class="form_box">
                <el-form ref="geoFenceForm" class="add_message" :model="geoFenceForm" :rules="geoFenceRules" label-width="120px">
                    <el-form-item label="围栏名称：" prop="remindName">
                        <el-input v-model="geoFenceForm.remindName" placeholder="请输入围栏名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="报警类型：" prop="remindSettingType">
                        <el-select class="widthInherit" v-model="geoFenceForm.remindSettingType" placeholder="请选择" @change="onRemindSettingTypeChange">
                            <el-option v-for="item in remindTypes" :label="item.desc" :value="item.code" :key="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="触发条件:" class="trigger-conditions" prop="triggerValue">
                        <el-row>
                            <el-col :span="14">
                                <el-select class="widthInherit" placeHolder="请选择" v-model="geoFenceForm.triggerValue">
                                    <el-option v-for="item in triggerValueOptions" :label="item" :value="item" :key="item"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="9" :offset="1">
                                <el-select class="widthInherit" placeHolder="请选择" v-model="geoFenceForm.triggerUnit" @change="onTriggerUnitChange">
                                    <el-option v-for="item in triggerUnitOptions" :label="item" :value="item" :key="item"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="围栏区域:" prop="regionId">
                        <el-select ref="mySelected" class="widthInherit" v-model="geoFenceForm.regionId" filterable placeholder="请选择围栏区域" @change="onRegionChanged">
                            <el-option v-for="item in regions" :key="item.id" :label="item.regionName" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="checkbox_item_style" label="提醒方式:" prop="remindMode">
                        <el-checkbox-group v-model="geoFenceForm.remindMode">
                            <el-checkbox v-for="item in remindModes" :label="item.code" :key="item.code">{{ item.desc }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <!-- <el-form-item :label="userInfo.tenantId == '10004' ? '绑定分公司' : '绑定车队'"> -->
                    <el-form-item label="选择分公司：" prop="subTenantTreeIds">
                        <el-cascader
                            popper-class="cascaderStyle"
                            class="widthInherit"
                            ref="companyRef"
                            v-model="geoFenceForm.subTenantTreeIds"
                            :options="subTenantTreeOptions"
                            :disabled="!subTenantTreeOptions || subTenantTreeOptions.length == 0"
                            :props="cascCaderProps"
                            placeholder="请选择"
                            :show-all-levels="false"
                            @change="onSubTenantTreeChanged"
                            filterable
                            clearable
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="提醒对象:" prop="reminderUserIds">
                        <el-select class="widthInherit" v-model="geoFenceForm.reminderUserIds" multiple placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in reminderUserIdOptions" :key="index" :label="item.nickName" :value="item.userId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否开启:" prop="enableFlag">
                        <el-switch v-model="geoFenceForm.enableFlag" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                    </el-form-item>
                </el-form>
                <!-- 地图区域 -->
                <map-fence ref="fenceRef" v-if="geoFenceFormVisible" :regionObj="regionObj"></map-fence>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="geoFenceFormVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="addOrEditGeoFence" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { BmlMarkerClusterer } from 'vue-baidu-map';
import MapFence from '@/components/mapFence.vue';
var _this = '';
export default {
    name: 'GeoFencing',
    components: {
        BmlMarkerClusterer,
        MapFence
    },
    props: {
        msg: String
    },
    data() {
        return {
            tableHeight: window.innerHeight > 700 ? 410 : 381,
            tableHeight1: window.innerHeight > 700 ? 410 : 327,
            geoFenceListLoading: false,
            geoFenceFormVisible: false,
            geoFenceFormTitle: '添加电子围栏',
            remindTypes: [],
            remindModes: [],
            regions: [],
            /* 电子围栏列表查询条件 */
            geoFenceListForm: {
                //储存搜索框的检索条件信息
                condition: {
                    keyword: ''
                },
                pageNo: 1,
                pageSize: 10
            },
            /* 通知人列表, 动态查询和设置 */
            reminderUserIdOptions: [],
            /* 缓存服务器查找到的字典信息，triggerUnitOptions 和 triggerValueOptions 动态从 triggerOptionsDict 中获取 */
            triggerOptionsDict: [],
            triggerUnitOptions: [],
            triggerValueOptions: [],
            /* 编辑和添加电子围栏信息 */
            geoFenceForm: {
                // 保留 tree 结构的 id 列表
                subTenantTreeIds: [],
                // 去除 tree 结构的 id 列表
                subTenantIds: [],
                reminderUserIds: [],
                enableFlag: true,
                remindSettingType: '',
                remindName: '',
                id: '',
                remindMode: [],
                regionId: null,
                triggerUnit: '',
                triggerValue: ''
            },
            geoFenceRules: {
                remindName: [{ required: true, message: '请输入', trigger: 'blur' }],
                remindSettingType: [{ required: true, message: '请选择', trigger: 'blur' }],
                triggerValue: [{ required: true, message: '请选择', trigger: 'blur' }],
                regionId: [{ required: true, message: '请选择', trigger: 'blur' }],
                remindMode: [{ required: true, message: '请选择', trigger: 'blur' }],
                subTenantTreeIds: [{ required: true, message: '请选择', trigger: 'blur' }],
                reminderUserIds: [{ required: true, message: '请选择', trigger: 'blur' }]
            },
            geoFenceListTotalPage: 1, //总页数,
            geoFenceList: [],
            regionObj: {},
            cascCaderProps: {
                multiple: true,
                checkStrictly: true,
                children: 'subTenantTreeLists',
                label: 'tenantName',
                value: 'tenantId',
                expandTrigger: 'hover'
            },
            subTenantTreeOptions: this.$store.state.common.companyTreeData
        };
    },
    mounted() {
        _this = this;
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.geoFenceListForm.companyId = this.userInfo.company;
        this.doFetchGeoFenceList();
        this.getEnumerationData();
    },
    methods: {
        getRegionNameByRegionId(id) {
            const item = this.regions.find((v) => v.id === id);
            return item ? item.regionName : '';
        },

        onRemindSettingTypeChange(row) {
            // 报警类型修改时，动态查询需要被禁用的选项
            this.$request({
                method: 'get',
                url: '/ubi/api/remind/setting/existsTenants',
                params: {
                    remindSettingType: this.geoFenceForm.remindSettingType,
                    remindSettingId: row ? row.id : null
                }
            }).then((res) => {
                if (res.code == 200) {
                    const treeData = structuredClone(this.subTenantTreeOptions);
                    const disableNum = this.disableNodesInTree(treeData, res.data);
                    this.subTenantTreeOptions = treeData;
                }
            });

            // 报警类型修改时，动态修改触发单位
            this.$request({
                method: 'post',
                url: '/ubi/api/dict/byAllDict',
                data: {
                    dictName: this.geoFenceForm.remindSettingType,
                    dictType: 'IOV_REMIND_TRIGGER_CONDITION'
                }
            }).then((res) => {
                if (res.code == 200 && res.data && res.data.length > 0) {
                    this.triggerOptionsDict = JSON.parse(res.data[0].metaData);
                    this.triggerUnitOptions = this.triggerOptionsDict.map((item) => item.triggerUnit);
                    const defaultTriggerUnit = ((this.triggerOptionsDict.find((item) => item.chooseFlag && item.chooseFlag == true) || {}).triggerUnit);
                    if (!this.geoFenceForm.triggerUnit) {
                        // 只有在新增时才设置默认值，保证不影响回显
                        this.geoFenceForm.triggerUnit = defaultTriggerUnit;
                    }
                    this.onTriggerUnitChange();
                }
            });
        },

        onTriggerUnitChange() {
            this.triggerValueOptions = ((this.triggerOptionsDict.find((item) => item.triggerUnit == this.geoFenceForm.triggerUnit) || {}).triggerValues) || [];
            // 触发单位修改时且赋值超出可选项，则清空
            if (this.geoFenceForm.triggerValue && !this.triggerValueOptions.includes(this.geoFenceForm.triggerValue)) {
                this.geoFenceForm.triggerValue = '';
            }
        },

        onSubTenantTreeChanged(val) {
            // 此处获得的是公司id二维数组，取每个数组最后一位
            val = val.map((sub) => sub[sub.length - 1]);
            // 服务器不需要保留 tree 结构
            this.geoFenceForm.subTenantIds = val;
            if (val.length == 0) {
                this.reminderUserIdOptions = [];
                this.geoFenceForm.reminderUserIds = [];
                return;
            }
            // 根据选中的公司 id 查询部门 id 对应的用户
            this.refreshTenantList();
        },

        refreshTenantList() {
            // 动态查询部门 id 对应的用户
            this.$request({ method: 'post', url: '/ubi/api/remind/setting/tenantUser', data: { tenantIds: this.geoFenceForm.subTenantIds } }).then((res) => {
                if (res.code == 200) {
                    this.reminderUserIdOptions = res.data;
                    if (this.geoFenceFormTitle == '编辑电子围栏') {
                        // 使用filter方法查找匹配项
                        this.geoFenceForm.reminderUserIds = res.data.filter((item) => this.geoFenceForm.reminderUserIds.includes(item.userId)).map((item) => item.userId);
                    } else {
                        // 默认选中所有
                        this.geoFenceForm.reminderUserIds = res.data.map((sub) => sub.userId);
                    }
                }
            });
        },

        onRegionChanged(val) {
            setTimeout(() => {
                this.regionObj = { value: this.$refs.mySelected.selected.value, label: this.$refs.mySelected.selected.label };
            }, 200);
        },

        // 获取枚举数据
        getEnumerationData() {
            // 获取事件类型
            this.$request({ method: 'get', url: '/ubi/api/enum/getFenceRemindTypeEnum' }).then((res) => {
                if (res.code == 200) {
                    this.remindTypes = res.data;
                }
            });
            // 获取提醒方式
            this.$request({ method: 'get', url: '/ubi/api/enum/getRemindModeEnum' }).then((res) => {
                if (res.code == 200) {
                    this.remindModes = res.data;
                }
            });
            // 获取行政区域
            this.$request({ method: 'get', url: '/ubi/api/fence/regions' }).then((res) => {
                if (res.code == 200) {
                    this.regions = res.data;
                }
            });
        },
        //点击结束报警
        handleOver(row) {
            this.$confirm('正在结束当前围栏报警, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({ method: 'get', url: '/ubi/api/fence/event/end', params: { eventId: row.id } }).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.data);
                            this.searchTable2();
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },

        // 操作添加围栏，清空所有表单和展示的数据
        onGeoFenceAddClicked(sign) {
            this.geoFenceFormTitle = '添加电子围栏';
            this.reminderUserIdOptions = [];
            this.geoFenceForm = {
                subTenantTreeIds: [],
                subTenantIds: [],
                reminderUserIds: [],
                enableFlag: true,
                // 如果只有1个，直接选中
                remindSettingType: '', //this.remindTypes.length == 1 ? this.remindTypes[0].code : '',
                remindName: '',
                id: '',
                remindMode: [],
                regionId: null,
                triggerUnit: [],
                triggerValue: ''
            };
            this.geoFenceFormVisible = true;
            this.regionObj.label = '';
        },

        // 点击电子围栏列表查询按钮
        onQueryGeoFenceListClicked() {
            this.geoFenceListForm.pageNo = 1;
            this.doFetchGeoFenceList();
        },
        disableNodesInTree(treeData, targetIds) {
            if (!Array.isArray(treeData) || treeData.length === 0 || !Array.isArray(targetIds) || targetIds.length === 0) {
                return 0;
            }

            let disabledCount = 0;

            for (const node of treeData) {
                // 匹配当前节点的tenantId
                if (targetIds.includes(node.tenantId)) {
                    node.disabled = true;
                    disabledCount++;
                }
                // 递归处理子节点
                if (Array.isArray(node.subTenantTreeLists) && node.subTenantTreeLists.length > 0) {
                    disabledCount += this.disableNodesInTree(node.subTenantTreeLists, targetIds);
                }
            }

            return disabledCount;
        },
        // 开关电子围栏
        toggleGeoFence(row, index) {
            var _statusName = row.enableFlag ? '停用' : '启用';
            this.$confirm('此操作将' + _statusName + '当前电子围栏报警, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    row.enableFlag = row.enableFlag ? 0 : 1;
                    this.$request({
                        method: 'post',
                        url: '/ubi/api/remind/setting/startAndStop',
                        data: {
                            enableFlag: row.enableFlag,
                            id: row.id
                        }
                    }).then((res) => {
                        if (res.code == 200) {
                            this.doFetchGeoFenceList();
                            row.enableFlag = !row.enableFlag;
                            this.$set(this.geoFenceList, index, row);
                            this.$message({
                                type: 'success',
                                message: res.message
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        //添加电子围栏
        addOrEditGeoFence() {
            this.$refs.fenceRef.getZoom();
            return;
            this.$refs.geoFenceForm.validate((valid) => {
                console.log('校验：', valid);

                if (!valid) {
                    return;
                }

                const { id, ...newFenceData } = this.geoFenceForm;
                if (this.geoFenceFormTitle == '编辑电子围栏') {
                    newFenceData.id = id;
                } else {
                    newFenceData.id = '';
                }

                this.$request({ method: 'post', url: '/ubi/api/remind/setting/add', data: newFenceData }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.message);
                        this.geoFenceFormVisible = false;
                        this.doFetchGeoFenceList();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            });
        },

        delGeoFence(row) {
            this.$confirm('此操作将删除当前电子围栏报警, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({
                        method: 'post',
                        url: '/ubi/api/remind/setting/delete/' + row.id
                    }).then((res) => {
                        if (res.code == 200) {
                            this.doFetchGeoFenceList();
                            this.$message({
                                type: 'success',
                                message: res.message
                            });
                        }
                    });
                })
                .catch(() => {});
        },

        // 点击编辑电子围栏
        editGeoFenceInfo(row) {
            // 重新初始化租户级联数据状态，避免上一次编辑部分被 disabled
            this.subTenantTreeOptions = this.$store.state.common.companyTreeData;

            const clonedData = structuredClone(row);
            this.geoFenceFormVisible = true;
            this.geoFenceFormTitle = '编辑电子围栏';
            this.geoFenceForm = clonedData;

            // 重新查询一次提醒对象
            this.refreshTenantList();
            // 重新刷新租户列表，禁用掉已经有的车队选项
            this.onRemindSettingTypeChange(row);

            // 回显电子围栏，查找 regionCode
            const item = this.regions.find((i) => i.id === this.geoFenceForm.regionId || i.regionCode === this.geoFenceForm.regionId);
            this.regionObj.label = (item && item.regionName) || '';
        },

        //获取电子围栏列表tbody里的数据
        doFetchGeoFenceList() {
            this.geoFenceListLoading = true;
            this.geoFenceList = []; //  清空table的值
            var json = JSON.parse(JSON.stringify(this.geoFenceListForm));
            this.$request({ method: 'post', url: '/ubi/api/remind/setting/page', data: json }).then((res) => {
                this.geoFenceListLoading = false;

                if (res.code == 200) {
                    var geoFenceList = res.data.list;
                    geoFenceList.length > 0 &&
                        geoFenceList.forEach((val, key) => {
                            val.enableFlag = Boolean(val.enableFlag);
                        });
                    this.geoFenceList = geoFenceList;
                    this.geoFenceListTotalPage = parseInt(res.data.total);
                }
            });
        },

        // 分页：当前页改变之后的函数
        onGeoFencePageNoChanged: function (val) {
            this.geoFenceListForm.pageNo = Number(val);
            this.doFetchGeoFenceList();
        }
    }
};
</script>
<style lang="less" scoped>
.bind_vehicle_dialog {
    padding-bottom: 20px;
}
#container {
    width: 4.5rem;
    height: 3.5rem;
}
.map_dialog {
    padding: 0.1rem 0 0.4rem;
}
#container_map {
    width: 8rem;
    height: 4rem;
    margin: 0 auto;
}
.search_box {
    margin-bottom: 20px;
}
.search_box .el-form--inline .el-form-item {
    margin-bottom: 0;
}
.time_quantum {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.time_quantum li {
    line-height: 1.4;
    padding: 5px 8px;
    border: 1px solid #666;
    border-radius: 5px;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    cursor: pointer;
}
.time_quantum .active {
    background-color: #409eff;
    color: #fff;
    border: 1px solid #409eff;
}
.add_message {
    width: 45%;
    margin-right: 15px;
    .el-form-item {
        // margin-bottom: 10px;
    }
    .checkbox_item_style {
        height: 15px;
        line-height: 15px;
        // border: 1px solid blue;
        /deep/ .el-form-item__content,
        /deep/ .el-form-item__label {
            height: 15px;
            line-height: 15px;
        }
    }
}
.table_box {
    margin-top: 0.2rem;
}
.risk_event {
    display: flex;
    width: 100%;
    padding: 0 0.2rem;
}
.risk_event div:first-child {
    margin-right: 2rem;
}
.event_item p {
    margin: 0.3rem 0 0.2rem;
    font-size: 0.2rem;
}
.detail_title {
    margin-bottom: 0;
}
.geoFencingPage {
    position: relative;
    height: 100%;
}
.hint_obj_box ::v-deep .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
}
.form_box {
    margin-top: 0.2rem;
    width: 100%;
    display: flex;
}
::v-deep .el-dialog__body {
    padding: 0 0.5rem;
}
.dialog_box {
    padding: 0 0 0.5rem;
}
.hint_title {
    margin-top: 0.15rem;
    font-size: #000;
}
.hint_info {
    margin-top: 0.2rem;
    border: 1px solid #c0c0c0;
    padding: 0.15rem 0.3rem;
    min-height: 1rem;
}
.trigger-conditions ::v-deep .el-select {
    width: 45%;
    margin-right: 10px;
}
</style>
